import { z } from 'zod'
import { yoastHeadJsonSchema } from '../types/yoast_head_json'

export const WpPageSchema = z
  .object({
    id: z.number(),
    link: z.string(),
  })
  .merge(yoastHeadJsonSchema)
